import {Middleware} from '@reduxjs/toolkit'
// import {Span} from '@sentry/types'

// import {changeLocation} from '@web/actions/application'
// import {getApplyFailure} from '@web/features/orderProcessor'
import {Sentry} from '@web/helpers/log'
// import {startApply} from '@web/slices/orderProcessor/slice'

import {initOrderSheetByAPI} from '../../../actions'
// import {redirectToOrderResult} from '../../../actions/order'
import {CheckoutRootState as RootState} from '../../../interfaces'

// let orderInitTransaction: Span | null = null
// let orderApplyTransaction: Span | null = null

// transaction을 종료하는 액션인지 검사
// const isFinish = isAnyOf(redirectToOrderResult.fulfilled)

// function finishTransaction(transaction: Span | null) {
//     if (transaction) {
//         transaction.setStatus({code: 1}).end()
//     }
// }

/** 주문서 관련  */
const sentryTransaction: Middleware<object, RootState> = () => (next) => (action) => {
    // 주문 승인 완료시
    // if (isFinish(action)) {
    //     finishTransaction(orderApplyTransaction)
    // }

    // 페이지 를 떠날때, finish
    // if (orderInitTransaction && changeLocation.type === action.type) {
    //     orderInitTransaction.setStatus({code: 1}).end()
    // }

    next(action)

    // 페이지 진입시 Transaction 세팅
    // if (initOrderSheet.pending.match(action)) {
    //     if (!orderInitTransaction) {
    //         orderInitTransaction = startTransaction({name: '주문서 조회'})
    //     }
    // }

    // 승인 요청 시
    // if (startApply.fulfilled.match(action)) {
    //     const {orderSheetId, orderNo, channelGroup} = action.payload ?? {}
    //     if (orderNo) {
    //         orderApplyTransaction = startTransaction({name: orderNo})
    //     }
    //     setTags({
    //         ...(orderSheetId ? {orderSheetId} : {}),
    //         ...(orderNo ? {orderNo} : {}),
    //         ...(channelGroup ? {channelGroup} : {}),
    //     })
    // }
    // 승인 실패
    // if (getApplyFailure.fulfilled.match(action)) {
    //     const {orderSheetId, orderNo} = action.payload ?? {}
    //     finishTransaction(orderApplyTransaction)
    //     setTags({
    //         ...(orderSheetId ? {orderSheetId} : {}),
    //         ...(orderNo ? {orderNo} : {}),
    //     })
    // }

    // 동일한 값이므로 중복 기록되어도 문제 없음
    if (initOrderSheetByAPI.fulfilled.match(action)) {
        Sentry.setTags({
            nidno: action.payload.data.purchaser.nidno,
            orderSheetId: action.payload.data.orderSheetId,
            channel: action.payload.data.saleChannelType,
            sellerRegister: action.payload.data.sellerRegisterType,
        })
    }
}

export default sentryTransaction
